import styled from "styled-components";

export const AboutLayout = styled.div`
    h3{
        font-size: 42px;
        font-weight: 900;
        text-align: center;
        padding-bottom: 30px;
    }
    p{
        font-size: 20px;
        text-align: center;
    }
    span{
        color: #DABAAD;
    }
    text-align: center;
    padding: 100px 50px;
`;

export const AboutUsLayout = styled.div`
    padding: 50px 0;
    h3{
        padding-top: 200px;
    }
`;

export const AboutStore = styled.div`
    width: 60%;
    margin: 0 auto;
    padding: 40px 0;
`

export const AboutValue=styled.div`
width: 100%;
margin-top:30px;
margin-bottom: 100px;
img{
    width: 80%;
    /* height: 50%; */
    border-radius: 100%;
}
`

export const ValueItem=styled.div`
    max-width: 45%;
    margin: 20px;   
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 20px;
    padding-top: 50px;
    b{
        font-size: 24px;
    }

`